import fp from 'lodash/fp';
import React from 'react';
import { ThemeProvider, createTheme, ThemeOptions } from '@mui/material';

import { theme, typographyOptions } from 'Modules/ui3';
import { ChainedRender } from 'Modules/core/react';


const muiTheme = createTheme(
    [
        theme,
        {
            spacing: abs => `${(0.4 * abs).toFixed(2)}rem`,
            typography: fp.mapValues(style =>
                fp.mapValues((v: string | number) => {
                    if (fp.isString(v) && v.includes('px')) {
                        const value = v.replace('px', '');
                        return `${+value / 10}rem`;
                    }
                    return v;
                }, style),
            typographyOptions.typography),
        } as ThemeOptions,
    ].reduce((r, c) => fp.merge(r, c)),
);

export const MuiThemeProviderRender: ChainedRender = ({ Next }) => (
    <ThemeProvider theme={muiTheme}>
        <Next />
    </ThemeProvider>
);
